module.exports = "https://cdn.dashboard.gifty.nl/5461/images/logo.png?610c4f2040c1206a8ecf2fe0b9f515b5";